module.exports = __webpack_public_path__ + "static/media/ordinary-day.90589de4.png";